module.exports = __webpack_public_path__ + "assets/img/yuezizhongxin.fe1bb173.png";